import { CustomHeader, Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import { Platform, TouchableOpacity, View, useWindowDimensions } from "react-native"
import { style } from "./styles"
import QRCode from "react-native-qrcode-svg"
import Modal from "react-native-modal"
import { BarcodeComponent } from "components/Barcode"
import AntDesign from "@expo/vector-icons/AntDesign"
import { translate } from "i18n"
import { useNavigation } from "@react-navigation/native"
import { colors } from "colors"
import { useStores } from "models"
import useResponsiveWidth from "components/fitSize"
import { useColor } from "app/theme/getThemes"

export const MemberQrScreen = () => {
  const { userStore } = useStores()
  const { companyTheme } = useColor()
  const [isModalVisible, setIsModalVisible] = useState(false)

  const [codeType, setCodeType] = useState("qr")
  const memberCode = userStore?.real_member_code

  // const { width } = useWindowDimensions()
  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const onCloseModal = () => {
    setIsModalVisible(false)
  }

  return (
    <>
      <>
        <View style={[style.fullcontainer, { backgroundColor: companyTheme.second }]}>
          <CustomHeader
            headerTitle={translate("memberQrScreen.title")}
            withBalls
            containerStyle={{ position: "absolute", top: 0, backgroundColor: "transparent" }}
          />
          <View style={style.container}>
            <View style={style.titleTextContainer}>
              <Text style={style.descriptionContainer}>
                {translate("memberQrScreen.description")}
              </Text>
            </View>
            <TouchableOpacity
              style={{ alignItems: "center", justifyContent: "center" }}
              onPress={() => {
                setIsModalVisible(true)
              }}
            >
              <QRCode size={200} value={memberCode} />
              <View style={{ marginTop: 10, width: "100%" }}>
                <BarcodeComponent format="CODE128" value={memberCode} width={2.5} />
              </View>

              <Text style={{ color: colors.lightGrey, marginTop: 5 }}>Click to zoom in</Text>
            </TouchableOpacity>

            <View
              style={[style.membershipNumberContainer, { backgroundColor: companyTheme.first }]}
            >
              <Text style={{ color: "white" }}>{translate("memberQrScreen.membershipNumber")}</Text>
              <Text style={style.membershipIdText}>{memberCode}</Text>
            </View>
          </View>
          <View style={style.ball1} />
          <View style={style.ball2} />
          <View style={style.ball3} />
          <View style={style.ball4} />
          <View style={style.ball5} />
          <View style={style.ball6} />
          <View style={style.ball7} />
          <View style={style.ball8} />
        </View>

        <Modal
          isVisible={isModalVisible}
          onBackdropPress={onCloseModal}
          onBackButtonPress={onCloseModal}
        >
          <View style={style.modalContainer}>
            <AntDesign
              onPress={onCloseModal}
              name="close"
              size={30}
              style={style.modalCloseButton}
            />

            <View style={style.modalQr}>
              {codeType === "barcode" ? (
                <TouchableOpacity
                  onPress={() => setCodeType("qr")}
                  style={{ alignItems: "center" }}
                >
                  <QRCode size={width - 100} value={memberCode} />
                  <>
                    <Text style={{ color: colors.lightGrey, marginTop: 20 }}>
                      Click to change to Barcode
                    </Text>
                  </>
                </TouchableOpacity>
              ) : (
                <TouchableOpacity
                  onPress={() => setCodeType("barcode")}
                  style={{ alignItems: "center" }}
                >
                  <BarcodeComponent format="CODE128" value={memberCode} width={2.5} />
                  <>
                    <Text style={{ color: colors.lightGrey, marginTop: 20 }}>
                      Click to change to QR
                    </Text>
                  </>
                </TouchableOpacity>
              )}
            </View>
          </View>
        </Modal>
      </>
    </>
  )
}
